import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { OrcamentoChartComponent } from './orcamento-chart.component/orcamento-chart.component';
import { VendaChartComponent } from './venda-chart.component/venda-chart.component';
import { IndicadoresDoDialComponent } from './indicadores-do-dia.component/indicadores-do-dia.component';
import { IndicadoresDoMesComponent } from './indicadores-do-mes.component/indicadores-do-mes.component';
import { ProdutosMaisVendidosChartComponent } from './produtos-mais-vendidos-chart.component/produtos-mais-vendidos-chart.component';
import { OrcamentosPorDiaSemanaChartComponent } from './orcamentos-por-dia-semana-chart.component/orcamentos-por-dia-semana-chart.component';
import { VendasPorDiaSemanaChartComponent } from './vendas-por-dia-semana-chart.component/vendas-por-dia-semana-chart.component';
import { VendaPedrasPorMesChartComponent } from './venda-pedras-por-mes-chart.component/venda-pedras-por-mes-chart.component';
import { MovimentoFinanceiroResumoComponent } from './movimento-financeiro-resumo.component/movimento-financeiro-resumo.component';
import { DespesasMensalComponent } from './despesas-mensal.component/despesas-mensal.component';
import { TopClientesChartComponent } from './top-clientes-chart.component/top-clientes-chart.component';



export interface DashboardStats {
  label: string;
  value: number;
  trend?: number; // Porcentagem de crescimento/queda
  type: 'currency' | 'numeric';
  color: 'blue' | 'emerald' | 'rose' | 'amber' | 'indigo' | 'slate';
  icon: string;
}


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule, IndicadoresDoDialComponent, IndicadoresDoMesComponent, ProdutosMaisVendidosChartComponent, OrcamentosPorDiaSemanaChartComponent, VendasPorDiaSemanaChartComponent, VendaPedrasPorMesChartComponent, MovimentoFinanceiroResumoComponent, DespesasMensalComponent, TopClientesChartComponent]
})
export class DashboardComponent  implements OnInit{


  ngOnInit(): void {
 
  }

 
}
